import { render, staticRenderFns } from "./Kbitem.vue?vue&type=template&id=74be3866&scoped=true&"
import script from "./Kbitem.vue?vue&type=script&lang=js&"
export * from "./Kbitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be3866",
  null
  
)

export default component.exports